<template>
  <div class="card-body">
    <div class="row d-flex flex-wrap justify-content-between align-items-center">
      <div class="col-3" v-for="(item, idx) in projectTeams" :key="idx">
        <div class="card border-1" style="width: 18rem;">
          <div class="card-body">
            <h5 class="card-title text-center">{{ item.team_role_label }}</h5>
            <img src="http://dev.miaccounts.net/images/avatar.jpg" class="card-img-top" alt="img">
            <p class="card-text text-center mt-2">
              {{ item.team_member_name }} <br>
              {{ item.designation }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TeamMemberList",
  props: {
    projectTeams: Array,
  }
}
</script>

<style scoped>

</style>